import { createSlice } from "@reduxjs/toolkit";
import { ordersTabs } from "../../../pages/orders/json/orderJson";

const initialState = {
  ordersData: [],
  selectedOrder: {
    tab: ordersTabs,
    activeTabs: "details",
    detailsData: {},
    productData: [],
    id: null,
    policyData: {},
    getAllOrderDocument: [],
  },
  transactionData: [],
};

const ordersSlice = createSlice({
  name: "orders",
  initialState: initialState,
  reducers: {
    setOrdersData: (state, action) => {
      state.ordersData = action.payload;
    },
    setTransactionData: (state, action) => {
      state.transactionData = action.payload;
    },
    changeActiveTabs: (state, action) => {
      state.selectedOrder.activeTabs = action.payload;
    },
    setDetailsData: (state, action) => {
      state.selectedOrder.detailsData = action.payload;
    },
    setProductData: (state, action) => {
      state.selectedOrder.productData = action.payload;
    },
    setOrderId(state, action) {
      state.selectedOrder.id = action.payload;
    },
    setPolicyData(state, action) {
      state.selectedOrder.policyData = action.payload;
    },
    setGetAllOrderDocument: (state, action) => {
      state.selectedOrder.getAllOrderDocument = action.payload;
    },
  },
});
export const {
  setOrdersData,
  setTransactionData,
  changeActiveTabs,
  setDetailsData,
  setProductData,
  setOrderId,
  setPolicyData,
  setGetAllOrderDocument,
} = ordersSlice.actions;

export default ordersSlice.reducer;
